import React, { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import SubNav from './SubNav';
import { localise } from '../../../services/lang/lang';
const SidebarSettings = () => {
    const { pathname } = useLocation();
    const orgProfileRef = useRef(null);
    const teamManagementRef = useRef(null);
    const links = [
        {
            options: [
                {
                    to: '/settings/organisation-profile/general',
                    label: localise('ORGANISATION_PROFILE'),
                    ref: orgProfileRef,
                },
                {
                    to: '/settings/team-management',
                    label: localise('TEAM_MANAGEMENT'),
                    ref: teamManagementRef,
                },
            ],
        },
    ];
    useEffect(() => {
        if (pathname.startsWith('/settings/organisation-profile/general')) {
            orgProfileRef.current?.focus();
        }
        else if (pathname.startsWith('/settings/team-management')) {
            teamManagementRef.current?.focus();
        }
    }, [pathname]);
    return React.createElement(SubNav, { links: links });
};
export default SidebarSettings;
